module.exports = __webpack_public_path__ + "img/image-thumb-16.c85286cc.jpg";